import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { useCookies } from '../../../common/CookiesProvider/useCookies';
import { useSearchFilters } from '../../../common/components/SearchHeader/filters/useSearchFilters';
import { VaccineType } from '../../../common/components/SearchHeader/types/VaccineChoice';
import { VACCINE_TYPE_PROMPT_COOKIE } from '../../../common/constants';
import { useRouter } from '../../../common/hooks/useRouter';
import { DropDownEnumFilter } from '../EnumFilter/DropDownEnumFilter/DropDownEnumFilter';
import { Option } from '../EnumFilter/RadioGroup/RadioGroup';
import { DropDownFilterPill } from '../FilterPill/DropDownFilterPill';
import { useOverlay } from '../overlay/OverlayContext';

const TITLE = 'Vaccine type';

export const VaccineTypeFilter = () => {
  const [filters, setFilters] = useSearchFilters();
  const { clear } = useOverlay();
  const router = useRouter();
  const { getData: getCookieData, saveData: saveCookieData } = useCookies();

  const options: Option<VaccineType | undefined>[] = [
    { label: 'Any', value: undefined },
    { label: 'Booster', value: VaccineType.BOOSTER },
    { label: 'Pfizer for 5-11s', value: VaccineType.PFIZER_FOR_5_11S },
    { label: 'Moderna for 6-11s', value: VaccineType.MODERNA_FOR_6_11S },
    { label: 'Moderna for 6mth to 5yrs', value: VaccineType.MODERNA_FOR_6M_5Y },
    { label: 'Novavax', value: VaccineType.NOVAVAX },
    { label: 'Pfizer', value: VaccineType.PFIZER },
    { label: 'Moderna', value: VaccineType.MODERNA },
    { label: 'AstraZeneca', value: VaccineType.ASTRAZENECA },
    { label: 'Moderna Bivalent', value: VaccineType.MODERNA_BIVALENT },
    { label: 'Pfizer Bivalent', value: VaccineType.PFIZER_BIVALENT },
    { label: 'Pfizer for 6mth to 4yrs', value: VaccineType.PFIZER_FOR_6M_4Y },
  ];

  const handleChange = (vaccineType: VaccineType | undefined | string): void => {
    setFilters({ ...filters, vaccineType });
    saveCookieData?.(VACCINE_TYPE_PROMPT_COOKIE, 't');
    clear();
  };

  const handleClear = () => {
    setFilters({ ...filters, vaccineType: undefined });
    saveCookieData?.(VACCINE_TYPE_PROMPT_COOKIE, 't');
  };

  const vaccineTypeSelected = Boolean(router?.query.vaccineType);
  const previouslyPrompted = Boolean(getCookieData?.(VACCINE_TYPE_PROMPT_COOKIE));

  const vaccineTypePrompted = vaccineTypeSelected || previouslyPrompted;

  return (
    <DropDownFilterPill
      hasValue={filters.vaccineType !== undefined}
      onClear={handleClear}
      caption={filters.vaccineType ?? TITLE}
      trackingId={LinkId.FILTER_BY_VACCINE_TYPE_BUTTON}
      initiallyActive={!vaccineTypePrompted}
      content={
        <DropDownEnumFilter<VaccineType | undefined | string>
          value={filters.vaccineType}
          filterTitle={TITLE}
          options={options}
          onChange={handleChange}
        />
      }
    />
  );
};
